import axios from 'axios'
import { useMutation, UseMutationResult, useQuery, UseQueryResult } from '@tanstack/react-query'
import { CmdTypes, RequestData, ResponseHeader } from 'src/types/type'
import {SERVER_URL} from "src/service/constants";

const useAPI = (cmdType: keyof CmdTypes): any => {
  const cmdTypeList: CmdTypes = {
    GetPartnerList: 'GetPartnerList',
    GetUiType: 'GetUiType',
    SENDCAPTCHAEXPRESS: 'SENDCAPTCHAEXPRESS',
    CheckMvnoMember: 'CheckMvnoMember',
    SENDOTPVERFY: 'SENDOTPVERFY',
    GetPartnerInfo: 'GetPartnerInfo',
    GetPartnerTerms: 'GetPartnerTerms',
    PartnerTerms: 'PartnerTerms',
    PartnerTermsDetail: 'PartnerTermsDetail',
  }

  const createHttpData: any = (
    cmdType: keyof CmdTypes,
    requestBody: unknown,
  ): RequestData<unknown> => {
    return {
      Header: {
        CmdType: cmdTypeList[cmdType],
      },
      Body: requestBody,
    }
  }
  const requestOWRS = async <T>(CmdType: keyof CmdTypes, ReqBody?: T): Promise<any> => {
    return await axios
      .post(`${SERVER_URL}`, JSON.stringify(createHttpData(CmdType, ReqBody)))
      .then(async (response) => {
        const { Header, Body } = JSON.parse(response?.data)
        return await handleError(Header, Body)
      })
      .catch((error) => {
        return error
      })
  }
  const handleError = async (Header: ResponseHeader, Body: any): Promise<any> => {
    if (Header?.ErrCode === 0) return { Header, Body }
    else {
      switch (Header?.ErrCode) {
        case 900004: {
          // alert('PCode에 UIType이 없습니다')
          return { Header, Body }
        }
        default:
          alert(
            Header?.ErrMsg ??
              `(${Header?.CmdType}) ${Header?.ErrCode} : 알 수 없는 오류가 발생했습니다.`,
          )
          return { Header, Body }
      }
    }
  }

  // react-query
  const useSetQuery = <T, E = unknown>(data: unknown): UseQueryResult<T | undefined, E> => {
    return useQuery([cmdType, data ?? {}], async () => await requestOWRS(cmdType, data))
  }
  type UseSetMutationReturnType<T> = UseMutationResult<T, Error, unknown>

  const useSetMutation = <T>(data: unknown): UseSetMutationReturnType<T> => {
    return useMutation([cmdType, data], async () => await requestOWRS(cmdType, data))
  }
  return {
    useSetQuery,
    useSetMutation,
  }
}
export default useAPI
